import { FBaseService } from '@kasasa/fbase-components/lib';
import { AxiosResponse } from 'axios';
import { AuditMessage } from './AuditMessage';

export class AuditMessageResource extends FBaseService {
  public async getAuditMessages(fiId: string): Promise<AuditMessage[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/reporting/${fiId}/audit`,
    );
    const rows: AuditMessage[] = response.data.data;
    return rows;
  }
}

export default AuditMessageResource;
